import { useNavigate } from "react-router-dom";
import { formatPrice } from "../../../../utils/price.utils";

const CartSummary = ({ mrpTotal, discountTotal, total, items = [] }) => {
    const navigate = useNavigate();

    return (
        <div className="cart-right sticky-summary">
            <h4 className="Price-Details-font"> Price Details ({items.length}) </h4>
            <div className="summary">
                <div className="trackvel total-font-size">
                    <div className="txt_title_cal font-width001"> Total MRP </div>
                    <div>{formatPrice(mrpTotal || 0)}</div>
                </div>

                <div className="trackvel total-discount-size">
                    <div className="txt_title_cal font-width001">Product Discount</div>
                    {discountTotal > 0 && (
                        <div style={{ color: "rgb(255, 63, 108)" }}>
                            {formatPrice(discountTotal)}
                        </div>
                    )}
                </div>

                <div className="summary-row total" style={{ borderTop:"1px solid #edeaea", padding:"11px 0px", fontSize:"15px" }}>
                    <div className="txt_title_cal">Sub Total</div>
                    <div style={{ color:"#000"}}> <span style={{color:"#000"}}>  {formatPrice(total || 0)} </span></div>
                </div>

                <button onClick={() => navigate("/checkout/init")} className="checkout">
                    CHECKOUT
                </button>

                <button
                    className="continue_shoping"
                    onClick={() => navigate("/")}
                  >
                    CONTINUE SHOPPING
                </button>
            </div>
        </div>
    );
};

export default CartSummary;